import DeleteIcon from "@material-ui/icons/Delete";

function ExpenseBreakdownModal({
  expenseLabel = "",
  items = [{ label: "", value: 0 }],
  onChange = () => { },
}) {
  const onChangeField = (index, field, newValue) => {
    const updatedItems = [...items];
    if (!updatedItems[index]) return;

    updatedItems[index] = {
      ...updatedItems[index],
      [field]: field === "value" ? newValue : newValue,
    };

    const sum = updatedItems.reduce(
      (acc, entry) => acc + (Number(entry.value) || 0),
      0
    );

    onChange(updatedItems, sum);
  };

  const addNewRow = () => {
    const updatedItems = [...items, { label: expenseLabel || "", value: 0 }];
    const sum = updatedItems.reduce(
      (acc, entry) => acc + (Number(entry.value) || 0),
      0
    );
    onChange(updatedItems, sum);
  };

  const deleteRow = (index) => {
    const updatedItems = items.filter((_, idx) => idx !== index);
    const finalItems =
      updatedItems.length > 0
        ? updatedItems
        : [{ label: expenseLabel || "Item 1", value: 0 }];

    const sum = finalItems.reduce(
      (acc, entry) => acc + (Number(entry.value) || 0),
      0
    );

    onChange(finalItems, sum);
  };

  return (
    <div className="p-0.5">
      <table
        className="w-full border-collapse text-[11px]"
        style={{ border: "1px solid #cbd5e1" }}
      >
        <thead>
          <tr className="bg-[#f0f2f5]">
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "50%" }}
            >
              Label
            </th>
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "35%" }}
            >
              Value
            </th>
            <th
              className="text-center font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "15%" }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td
                  className="p-0 bg-[#ffffd6]"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  <input
                    type="text"
                    value={item.label ?? ""}
                    placeholder={expenseLabel || "Label"}
                    onChange={(e) =>
                      onChangeField(index, "label", e.target.value)
                    }
                    className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 outline-none border-none"
                  />
                </td>
                <td
                  className="p-0 bg-[#ffffd6]"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  <input
                    type="number"
                    value={item.value === 0 || item.value === "" ? "" : item.value ?? ""}
                    placeholder=""
                    onChange={(e) =>
                      onChangeField(
                        index,
                        "value",
                        e.target.value === "" ? 0 : Number(e.target.value)
                      )
                    }
                    className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 outline-none border-none"
                  />
                </td>
                <td
                  className="p-0 text-center bg-white align-middle"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  <DeleteIcon
                    style={{ cursor: "pointer", color: "blue", fontSize: 15 }}
                    onClick={() => deleteRow(index)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <button
        type="button"
        onClick={addNewRow}
        className="mt-2.5 px-2.5 py-1 bg-[#313C4C] text-white text-[11px] font-semibold rounded hover:bg-[#0c2f50] transition-colors cursor-pointer"
      >
        + Add
      </button>
    </div>
  );
}

export default ExpenseBreakdownModal;
